"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildSelectorVariant;

var _postcssSelectorParser = _interopRequireDefault(require("postcss-selector-parser"));

var _tap = _interopRequireDefault(require("lodash/tap"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function buildSelectorVariant(selector, variantName, separator) {
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  return (0, _postcssSelectorParser.default)(function (selectors) {
    (0, _tap.default)(selectors.first.filter(function (_ref) {
      var type = _ref.type;
      return type === 'class';
    }).pop(), function (classSelector) {
      if (classSelector === undefined) {
        onError('Variant cannot be generated because selector contains no classes.');
        return;
      }

      classSelector.value = "".concat(variantName).concat(separator).concat(classSelector.value);
    });
  }).processSync(selector);
}